<div class="details-contacts__container" [class.mobile]="rwdService.isSmallDevice">
  <div class="details-contacts">
    <div class="phone" *ngFor="let phone of stringArray(personalData.phone)">
      <app-contact-link [phone]="phone"></app-contact-link>
      <button
        *ngIf="canCall"
        mat-icon-button
        type="button"
        color="primary"
        class="phone__call"
        [disabled]="!!callingPhone"
        [matTooltip]="(callingPhone === phone ? 'connection.callPending' : 'connection.callResident') | loc"
        [attr.aria-label]="(callingPhone === phone ? 'connection.callPending' : 'connection.callResident') | loc"
        (click)="call(phone)"
      >
        <mat-spinner *ngIf="callingPhone === phone; else callIcon" diameter="20"></mat-spinner>
        <ng-template #callIcon><mat-icon>phone_in_talk</mat-icon></ng-template>
      </button>
      <app-app-invitation
        *ngIf="canInvite && !personalData.userId"
        [invTemplate]="getInvitation(phone)"
        [inviteSent]="inviteSent"
        [invitedNumber]="isInvitedNumber(phone)"
      ></app-app-invitation>
    </div>
    <div *ngIf="!personalData.phone">
      <app-contact-link [phone]="null"></app-contact-link>
    </div>
    <div *ngFor="let email of stringArray(personalData.email)">
      <app-contact-link [email]="email"></app-contact-link>
    </div>
    <div *ngIf="!personalData.email">
      <app-contact-link [email]="null"></app-contact-link>
    </div>
  </div>

  <div class="buttons">
    <app-new-message-button
      *ngIf="personalData.userId && canMessage"
      [userId]="personalData.userId"
      [residentId]="personalData.id"
    >
    </app-new-message-button>
    <app-icon-button *ngIf="canAlert" [fliko]="true" [inverse]="true" icon="email" (click)="sendAlert()">
      {{ 'button.sendAlert' | loc }}
    </app-icon-button>
    <app-icon-button [fliko]="true" icon="feedback" (click)="showEventLog()">
      {{ 'user.showActivity' | loc }}
    </app-icon-button>
    <app-icon-button [fliko]="true" icon="history" (click)="showResidentHistory()">
      {{ 'label.changeHistory' | loc }}
    </app-icon-button>
  </div>
</div>
